var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"unityFrame",attrs:{"id":"unityContainer","allowfullscreen":"","src":`/modulesViewer.html?url=${_vm.selectedGroup.id}/${_vm.selectedAsset.id}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }